import clsx from "clsx"
import { PropsWithChildren } from "react"

export const Container = ({ children, className }: PropsWithChildren & { className?: string }) => {
  return <div className={clsx("container max-w-[1170px] margin-center !px-4 xl:!px-0 py-10", className)}>{children}</div>
}
